import { html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { styleMap } from 'lit/directives/style-map.js';
import { createView } from './view.js';
import { spread } from './utils/spread.js';

export function Slot(name?: string) {
  return createView(
    ({ attrs, styles }) => html`
      <slot
        ${spread(attrs)}
        style="${styleMap(styles)}"
        name="${ifDefined(name)}"
      ></slot>
    `
  );
}
